import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, SocialElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<SocialElement>["defaultData"] = {
  attributes: {
    align: "center",
    "border-radius": "3px",
    color: "#333333",
    "font-family": "Arial",
    "font-size": "13px",
    "icon-size": "20px",
    "line-height": "22px",
    mode: "horizontal",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    "text-decoration": "none",
  },
  data: {},
};

export const Social = createBlock<SocialElement>({
  get name() {
    return t("Social");
  },
  defaultData,
  type: BasicType.SOCIAL,
  create: (payload) => {
    const defaultData: SocialElement = {
      type: BasicType.SOCIAL,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SOCIAL,
  render(params) {
    return <BasicBlock params={params} tag="mj-social" />;
  },
});
